export class ScheduleRepeat {
    Value: string;
    Name: string;
}

export enum EScheduleRepeat {
    NotRepeat = 'not_repeating',
    Days = 'days',
    Weeks = 'weeks',
    Months = 'months',
}
